export interface EnvironmentConfig {
  BACKEND_URL: string | undefined;
  SALT: string | undefined;
}

export const environmentConfig: EnvironmentConfig = {
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
  SALT: import.meta.env.SALT,
};
